import { PARK_STATUS_OPTIONS } from "./materielConstants";

// Règles du parc matériel : échéances de location, indicateurs, filtres et formulaire d'une fiche.

export function rentalDaysLeft(item, today = new Date()) {
    if (!item?.currentRentalEndDate) return null;
    const start = new Date(today);
    start.setHours(0, 0, 0, 0);
    const end = new Date(`${item.currentRentalEndDate}T00:00:00`);
    return Math.ceil((end.getTime() - start.getTime()) / 86400000);
}

export function rentalAlertText(item, today = new Date()) {
    const days = rentalDaysLeft(item, today);
    if (days === null) return "Aucune échéance";
    if (days < 0) return `Location échue depuis ${Math.abs(days)} j`;
    if (days === 0) return "Location à terme aujourd'hui";
    return `Terme dans ${days} j`;
}

export function rentalAlertTone(item, today = new Date()) {
    const days = rentalDaysLeft(item, today);
    if (days === null) return "#5A6D68";
    if (days < 0) return "#B91C1C";
    if (days <= 7) return "#A16207";
    return "#0C3B3C";
}

export function parkStatusLabel(status) {
    return PARK_STATUS_OPTIONS.find(option => option.value === status)?.label || "Disponible";
}

export function parkStatusColors(status) {
    if (status === "RENTED") return { bg: "#E9F8F1", color: "#0C3B3C", border: "#17B978" };
    if (status === "MAINTENANCE") return { bg: "#FFF7E0", color: "#7A5A00", border: "#C8A44D" };
    return { bg: "#F4F1EA", color: "#0C3B3C", border: "#D9D2C4" };
}

export function parkMetrics(items) {
    return [
        { label: "Total parc", value: items.length },
        { label: "Disponibles", value: items.filter(item => item.status === "AVAILABLE").length },
        { label: "En location", value: items.filter(item => item.status === "RENTED").length },
        { label: "À entretenir", value: items.filter(item => item.status === "MAINTENANCE").length },
    ];
}

// Locations échues ou à terme dans les sept jours.
export function dueSoonCount(items, today = new Date()) {
    return items.filter(item => {
        const days = rentalDaysLeft(item, today);
        return days !== null && days <= 7;
    }).length;
}

export function filterParkItems(items, query, statusFilter) {
    const normalizedQuery = query.trim().toLocaleLowerCase("fr");
    return items.filter(item => {
        const text = [
            item.internalNumber,
            item.matriculeName,
            item.currentTenant,
            item.currentTenantEmail,
            item.currentTenantPhone,
            item.maintenanceProcedureName,
            item.notes,
        ].filter(Boolean).join(" ").toLocaleLowerCase("fr");
        return (!normalizedQuery || text.includes(normalizedQuery))
            && (!statusFilter || item.status === statusFilter);
    });
}

export function parkItemToForm(item) {
    return {
        internalNumber: item.internalNumber || "",
        matriculeName: item.matriculeName || "",
        purchaseDate: item.purchaseDate || "",
        status: item.status || "AVAILABLE",
        currentTenant: item.currentTenant || "",
        currentTenantEmail: item.currentTenantEmail || "",
        currentTenantPhone: item.currentTenantPhone || "",
        currentRentalStartDate: item.currentRentalStartDate || "",
        rentalDurationDays: item.rentalDurationDays || "",
        currentRentalEndDate: item.currentRentalEndDate || "",
        installationRequired: Boolean(item.installationRequired),
        maintenanceRequired: Boolean(item.maintenanceRequired),
        maintenanceProcedureId: item.maintenanceProcedureId || "",
        notes: item.notes || "",
    };
}

// Fiche envoyée au serveur : la procédure d'entretien n'est gardée que si l'entretien est nécessaire.
export function parkItemPayload(form, editingItem) {
    return {
        ...form,
        id: editingItem?.id || null,
        version: editingItem?.version ?? null,
        maintenanceProcedureId: form.maintenanceRequired && form.maintenanceProcedureId ? Number(form.maintenanceProcedureId) : null,
        rentalDurationDays: form.rentalDurationDays ? Number(form.rentalDurationDays) : null,
    };
}
